import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-flush h-md-100" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body pt-1" }
const _hoisted_5 = { class: "fw-bolder text-gray-600" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "card-footer flex-wrap pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.nom), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, "Total des permissions pour ce rôle: " + _toDisplayString(_ctx.privileges?.length), 1),
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredDescriptions, (description, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", null, _toDisplayString(description), 1)
            ]))
          }), 128)),
          (_ctx.showMore)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
                _createElementVNode("td", _hoisted_8, "et " + _toDisplayString(_ctx.number - 4) + " de plus...", 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_router_link, {
        to: { name: 'ViewRolePage', params: { id: _ctx.id } },
        class: "default-btn me-2 text-white btn bg-success btn-md"
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "fa fa-eye lh-3 position-relative top-1" }, null, -1)
        ])),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: { name: 'EditRolePage', params: { id: _ctx.id } },
        class: "btn btn-md btn-primary my-1 me-2"
      }, {
        default: _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "fa fa-pencil lh-3 position-relative top-1" }, null, -1)
        ])),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('delete'))),
        class: "btn btn-md btn-danger btn-active-danger my-1"
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("i", { class: "fa fa-trash lh-3 position-relative top-1" }, null, -1)
      ]))
    ])
  ]))
}